<template>
  <div class="speaker">
    <div class="container">
      <ShadowTitle :title="`Спикеры мероприятия`"
                   title-shadow="HEROES ELS SPACE"
      />
      <div class="speaker-wrap mb-5">
        <div class="speaker-content">
          <div class="speaker-head _mobile"/>
          <div class="speaker-image" ref="speakerImage">
            <img class="img-fluid" :src="require(`@/assets/speaker-bg.png`)">
          </div>
          <div class="speaker-body ms-auto">
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text">
                Основатель и владелец ГК ЕЮС, в рамках которой развиваются самые популярные сервисные
                высокотехнологичные проекты в России: «Юрист 24», «ЕЮС Брокер», «ТЕЛЕДОКТОР 24», «Налогия»,
                «Добросервис» и другие
              </div>
              <div class="speaker-desc-logo">
                <img class="img-fluid" :src="require(`@/assets/logos/els.svg`)">
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text">
                Основатель бизнес-пространства ELS SPACE
              </div>
              <div class="speaker-desc-logo">
                <img class="img-fluid" :src="require(`@/assets/logos/els-space.svg`)">
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text">
                Контрибьютор российской редакции Forbes
              </div>
              <div class="speaker-desc-logo">
                <img class="img-fluid" :src="require(`@/assets/logos/forbes.svg`)">
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text">
                Эксперт фонда Сколково
              </div>
              <div class="speaker-desc-logo">
                <img class="img-fluid" :src="require(`@/assets/logos/sk.svg`)">
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text">
                Член генерального совета<br> ООО «Деловая Россия»
              </div>
              <div class="speaker-desc-logo">
                <img class="img-fluid" :src="require(`@/assets/logos/del-ros.svg`)">
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Идеолог и основатель Фонда развития правовой культуры и правосознания
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Бизнес-посол РФ во Вьетнаме
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Победитель премии «Я был прав!» компании Trout & Partners
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Лауреат «Entrepreneur Of The Year 2019 by Ernst & Young»
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Победитель федеральной премии «Человек дела»
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                ТОП-250 высших руководителей рейтинга<br> «ТОП-1000 Российских менеджеров»
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                <p>
                  <b>
                    Создает культуру эволюции личности и пространство развития, в котором человек может стать
                    большим
                    собой.
                  </b>
                </p>
                <p>
                  Верит в развивающие знания, сам идет по этому пути и хочет, чтобы по этому пути прошло как можно
                  больше людей. Новое качество жизни приходит через новое знание и постоянно преобразующий личность
                  опыт на Пути Героя.
                </p>
                <p>
                  Фактически создает полис будущего, где граждане равноправны, все роли выбираемые, и каждый может
                  претендовать и <b>проявляться именно в той роли, которая провоцирует его быть еще большим
                  собой</b> и приносить еще больше пользы окружающим.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShadowTitle from "@/components/ShadowTitle";

export default {
  name: "Speaker",
  components: {ShadowTitle},
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const speakerWrap = this.$el.querySelector('.speaker-wrap');
      const speakerImage = this.$el.querySelector('.speaker-image');
      const offsetTop = speakerWrap.getBoundingClientRect().top + window.scrollY;
      const offsetBottom = offsetTop + speakerWrap.offsetHeight - speakerImage.offsetHeight;

      // Проверяем, не достигли ли мы нижней части блока speaker-wrap
      if (window.scrollY > offsetBottom) {
        speakerImage.style.position = 'absolute';
        speakerImage.style.bottom = '0';
        speakerImage.style.top = 'auto';
      }
      // Проверяем, находится ли скролл в пределах блока speaker-wrap
      else if (window.scrollY > offsetTop) {
        speakerImage.style.position = 'fixed';
        speakerImage.style.top = '1rem';
        speakerImage.style.bottom = 'auto';
      } else {
        speakerImage.style.position = 'absolute';
        speakerImage.style.top = '0';
        speakerImage.style.bottom = 'auto';
      }
    }
  }
}
</script>


<style lang="scss" scoped>
.speaker-wrap {
  position: relative;
  background: linear-gradient(339.26deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 8.85%, rgba(255, 255, 255, 0) 86.98%, rgba(255, 255, 255, 0.08) 100%),
  linear-gradient(0deg, #0D0D10, #0D0D10);
  box-shadow: 0 4px 76px 0 #00000099;
  border-radius: 16px;

  @include _992 {
    padding: 0;
    background: none;
    box-shadow: none;

    &._second {

      .speaker-desc-item {
        min-height: 130px;
      }
    }
  }

  .speaker-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: start;
    position: relative;
  }

  .speaker-image {
    overflow: hidden;
    background: #0D0D10;
    border-radius: 16px;
    box-shadow: 0 4px 76px 0 #00000099;
    display: none;
    width: 100%;
    transition: all 0.3s;

    @include _992 {
      position: absolute;
      max-width: 48%;
      width: 100%;
      display: flex;
    }
    @include _1200 {
      max-width: 590px;
    }
  }

  .speaker-body {
    position: relative;
    z-index: 5;
    width: 100%;
    padding: 100% 1rem 1rem 1rem;
    @include _992 {
      width: 48%;
      padding: 0;
    }
  }
}

.speaker-head {
  height: 100%;
  width: 100%;
  background: url(~@/assets/speaker-bg-mob.png) no-repeat top center;
  background-size: 100%;
  border-radius: 16px;
  position: absolute;
  top: 0;
  z-index: 1;
  @include _992 {
    display: none;
  }
}

.speaker-desc-item {
  border-radius: 16px;
  background: var(--deep-dark, #1B1B21);
  display: flex;
  flex-direction: column;
  padding: 24px 18px;
  align-items: center;
  @include _576 {
    flex-direction: row;
    justify-content: space-between;
  }

  .speaker-desc-text {
    width: 100%;
    color: var(--gray, #C7C7D1);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 128%; /* 20.48px */

    br {
      display: none
    }

    @include _576 {
      width: 60%;
      br {
        display: block
      }
    }
    @include _768 {
      margin-bottom: 0;
    }
  }

  .speaker-desc-logo {
    width: 100%;
    display: flex;
    margin-top: 8px;
    @include _576 {
      width: 40%;
      align-items: center;
      justify-content: center;
    }
  }
}

.speaker-wrap {
  &._second {
    .speaker-head {
      background: url(~@/assets/speaker-bg-2-mob.png) no-repeat top center;
      background-size: 100%;
    }
  }
}
</style>